// src/components/SEO.js
import React from "react";
import { Helmet } from "react-helmet";

const SEO = ({ title, description, image, url }) => {
  const defaultImage = "%PUBLIC_URL%/img/restaurant_pos__1.png";
  const keywords =
    "erp software, erp system, custom software, inventory management system, pos software, school management system, web development, saas solutions, mobile app development, cloud devops, ai solutions, oracle erp, sap erp, accounting software, restaurant pos, erp full form, erp benefits, zoho inventory, inventory meaning, inventory software, is inventory an asset, abc inventory, maslach burnout inventory mbi, pos system, pos meaning, what is pos, pos system meaning, square point of sale, point of sale systems, hms, web app, webapp, webapps, ehospital, web application firewall, web application development, web application security, web application framework, web application testing, web application architecture, web application hosting, web application design, web application development company, web application development services, web application development framework, web application development tools, web application development process, web application development technologies, web application development best practices, web application development trends, web application development challenges, web application development cost, web application development company near me, web application development company in world, web application development company in industry, web application development company in market, web application development company in Pakistan, web application development company in Canda, web application development company in USA, web application development company in UK, web application development company in Australia, web application development company in Dubai, web application development company in Saudi Arabia";

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "MZR Software",
    url: url,
    logo: defaultImage,
    sameAs: [
      "https://www.facebook.com/MZRSoftware",
      "https://www.linkedin.com/company/mzr-software",
      "https://twitter.com/MZRSoftware",
    ],
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "+92-XXX-XXXXXXX",
      contactType: "Customer Support",
      areaServed: "PK",
    },
  };

  const websiteStructuredData = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "MZR Software",
    url: url,
    potentialAction: {
      "@type": "SearchAction",
      target: `${url}/search?q={search_term_string}`,
      "query-input": "required name=search_term_string",
    },
  };

  return (
    <Helmet>
      {/* Page Title */}
      <title>{title}</title>

      {/* Standard Meta */}
      <meta charSet="UTF-8" />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="MZR Software" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="robots" content="index,follow" />
      <link rel="canonical" href={url} />

      {/* Open Graph / Facebook */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image || defaultImage} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="MZR Software" />
      <meta property="og:locale" content="en_US" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image || defaultImage} />

      {/* JSON-LD Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(websiteStructuredData)}
      </script>
    </Helmet>
  );
};

export default SEO;
